/*
================================================================
	Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
	File Description : Common Header Component
----------------------------------------------------------------
	Creation Details
	Date Created				: 25/Jun/2020
	Author						: YOGESH N. GUPTA
================================================================
*/

import "./index.scss";
import React, { memo, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { userSignout } from "../../../middleware/actions/authAction";
import { getLoggedInUser, getProductVariant, isAdmin } from "../../../utilities";
import { fetchTrendsList, fetchIndustriesList } from "../../../middleware/actions/searchAction";

const Header = (props) => {
  const { pageHeading } = props;

  const loggedInUser = getLoggedInUser();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");

  useEffect(() => {
    try {
      dispatch(fetchIndustriesList());
      dispatch(fetchTrendsList());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  return (
    // <nav
    //   className="navbar navbar-expand-lg navbar-light"
    //   style={{ padding: getProductVariant() == "Insider" && accessRightCheck("Site Search", "Listing") ? "" : "13px 10px" }}
    // >
    //   <div className="container-fluid">
    //      {/* Header Name  */}
    //     {getProductVariant() == "Insider" && accessRightCheck("Site Search", "Listing") ? (
    //       <>
    //         <div className="col-md-2 page_title pl-0">
    //           <h3>{pageHeading}</h3>
    //         </div>
    //         <div className="col-md-8 page_title pl-0">
    //           <TopSearchBox
    //             placeholder='Enter Keyword e.g. "Mobility Cloud"'
    //             onTextChange={onTextChange}
    //             onClick={searchHandler}
    //             isError={isError}
    //             setIsError={setIsError}
    //             handleKeyDown={handleKeyDown}
    //             setInputValue={setInputValue}
    //             className="!w-full "
    //           />
    //         </div>
    //       </>
    //     ) : (
    //       <div className="col-md-10 page_title pl-0">
    //         <h3>{pageHeading}</h3>
    //       </div>
    //     )}
    //       {/* product variant text  */}
    //     <div>
    //       <h6 className="inset">{getProductVariant()}</h6>
    //     </div>

    //       {/* dropdown btn  */}
    //     <div className="col-md-1">
    //       {/* <div className="user_info_section" style={{ marginLeft: "-26px" }}> */}
    //       <div className="user_info_section">
    //         <div className="user_info_detail d-inline-block">
    //           <div className=" dropdown ">
    //             <Link
    //               to="#"
    //               className="btn btn-secondary dropdown-toggle px-3 d-flex align-items-center"
    //               role="button"
    //               id="dropdownMenuLink"
    //               data-toggle="dropdown"
    //               aria-haspopup="true"
    //               aria-expanded="false"
    //               style={{ gap: "8px" }}
    //             >
    //               <i className="fas fa-user" style={{ textTransform: "capitalize",fontSize:'20px'}} aria-hidden="true" />
    //               Hello{" "}
    //               {loggedInUser?.user_fname?.length > 10 ? loggedInUser?.user_fname.slice(0, 9) + ".." : loggedInUser?.user_fname}

    //             </Link>
    //             <div className=" dropdown-menu p-0 " aria-labelledby="dropdownMenuLink">
    //               {(isAdmin() || !loggedInUser?.product_variant?.length || loggedInUser?.product_variant?.length > 1) && (
    //                 <Link
    //                   to={{
    //                     pathname: "/selector",
    //                   }}
    //                   className="dropdown-item"
    //                   style={{ padding: ".5rem .75rem" }}
    //                   title="Product Variant Selection"
    //                   onClick={() => localStorage.removeItem("productVariant")}
    //                 >
    //                   Product Variant
    //                 </Link>
    //               )}

    //               {userType === "External" ? (
    //                 <Link
    //                   to={`/my-profile/${loggedInUser?._id}/edit#profile`}
    //                   className="dropdown-item"
    //                   style={{ padding: ".5rem .75rem" }}
    //                   title="Product Variant Selection"
    //                 >
    //                   My Profile
    //                 </Link>
    //               ) : null}
    //               <Link to="#" className="dropdown-item border-top" style={{ padding: ".5rem .75rem" }} onClick={() => dispatch(userSignout({}))}>
    //                 Logout
    //               </Link>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </nav>
    <div className="w-100 d-flex navbar-container">
      <div className="page_title d-flex align-items-center w-25p">
        <h3>{pageHeading}</h3>
      </div>
      {/* User info and logout section */}
      <div className="d-flex align-items-center justify-content-end w-25p" style={{ gap: "1.3rem" }}>
        <div className="d-flex align-items-center">
          <div className="text-white fw-normal">{getProductVariant()}</div>
        </div>
        <div className="d-flex">
          <div className="user_info_detail">
            <div className=" dropdown ">
              {/* <Link
                  to="#"
                  className="btn btn-secondary dropdown-toggle px-3 d-flex align-items-center"               
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ gap: "8px" }}
                >
                  <i className="fas fa-user" style={{ textTransform: "capitalize",fontSize:'1.25rem'}} aria-hidden="true" /> 
                  Hello{" "}
                  {loggedInUser?.user_fname?.length > 10 ? loggedInUser?.user_fname.slice(0, 9) + ".." : loggedInUser?.user_fname} 
                </Link> */}
              <button
                className="btn btn-primary dropdown-toggle px-3 d-flex align-items-center"
                id="dropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ gap: "8px" }}
              >
                <i className="fas fa-user" style={{ textTransform: "capitalize", fontSize: "1.25rem" }} aria-hidden="true" />
                Hello {loggedInUser?.user_fname?.length > 10 ? loggedInUser?.user_fname.slice(0, 9) + ".." : loggedInUser?.user_fname}
              </button>
              <div className=" dropdown-menu p-0 " aria-labelledby="dropdownMenuLink">
                {(isAdmin() || !loggedInUser?.product_variant?.length || loggedInUser?.product_variant?.length > 1) && (
                  <Link
                    to={{
                      pathname: "/selector",
                    }}
                    className="dropdown-item"
                    style={{ padding: ".5rem .75rem" }}
                    title="Product Variant Selection"
                    onClick={() => localStorage.removeItem("productVariant")}
                  >
                    Product Variant
                  </Link>
                )}

                {userType === "External" ? (
                  <Link
                    to={`/my-profile/${loggedInUser?._id}/edit#profile`}
                    className="dropdown-item"
                    style={{ padding: ".5rem .75rem" }}
                    title="Product Variant Selection"
                  >
                    My Profile
                  </Link>
                ) : null}
                <Link to="#" className="dropdown-item border-top" style={{ padding: ".5rem .75rem" }} onClick={() => dispatch(userSignout({}))}>
                  Logout
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Header);

Header.propTypes = {
  pageHeading: PropTypes.string.isRequired,
};
